<template>
  <div>
    <portal to="app-header">
      <v-btn icon :to="{ path: '/production-planning' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="d-inline-block" style="line-height:80px;">
        {{$t('reportexport.title')}}
      </div>
      <!-- <v-btn icon @click="refresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn> -->
    </portal>
    <v-row class="pa-2">
      <v-col cols="12" sm="3">
        <v-autocomplete
          clearable
          filled
          :label="$t('reportexport.reportname')"
          :items="reportlist"
          return-object
          v-model="report"
          item-text="name"
          item-value="name"
        >
        <template #item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-title v-text="item.description_cn"></v-list-item-title>
            <v-list-item-title v-text="item.description_en"></v-list-item-title>
          </v-list-item-content>
        </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          clearable
          filled
          :label="$t('reportexport.startdate')"
          v-model="searchstartdate"
          type="date"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          clearable
          filled
          :label="$t('reportexport.enddate')"
          v-model="searchenddate"
          type="date"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
      color="success"
      outlined
      class="mt-5 mr-2"
      :loading="saving"
      @click="search()"
      :disabled="searchbtndisabled"
      >
        {{$t('reportexport.searchbtn')}}
      </v-btn>
      <v-btn
      color="primary"
      class="mt-5 mr-2"
      :loading="saving"
      @click="reportexport = [], showParamDialog = true"
      >
        {{$t('reportexport.createbtn')}}
      </v-btn>
      <v-btn
      color="error"
      outlined
      class="mt-5 mr-5"
      :loading="saving"
      @click="handleDelete"
      :disabled="reportexport.length === 0 || reportexport.some(i => i.status === 0)"
      >
        {{$t('reportexport.deletebtn')}}
      </v-btn>
    </v-row>
    <div class="pa-2">
      <v-data-table
        height="600"
        fixed-header
        v-model="reportexport"
        show-select
        :items="reportexportlist"
        :headers="reportexportheaders"
        hide-default-footer
        disable-pagination
        item-key="_id"
        :calculate-widths="false"
        width="100%"
      >
        <template #item.hasRecord="{ item }">
          <span>
            {{item.hasRecord ? $t('reportexport.booltrue') : $t('reportexport.boolfalse')}}
          </span>
        </template>
        <template #item.path="{ item }">
          <span
          v-if="item.path"
          style="cursor: pointer;text-decoration: underline;color: #2440b3;"
          @click="handleDownload(item)"
          >
            {{`${host}/reportexport/${item.path}`}}
          </span>
        </template>
      </v-data-table>
    </div>
    <param-dialog
    :reportlist="reportlist"
    :showParamDialog="showParamDialog"
    @cancel="showParamDialog = false"
    @search="search"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import ParamDialog from '../components/ParamDialog.vue';

export default {
  data() {
    return {
      host: window.location.host,
      report: null,
      reportlist: [],
      searchstartdate: '',
      searchenddate: '',
      reportexport: [],
      reportexporttags: [
        'startdate',
        'enddate',
        'reportname',
        'statusformat',
        'path',
        'hasRecord',
        'user',
        'createdTimestamp',
      ],
      reportexportheaders: [],
      reportexportlist: [],
      saving: false,
      showParamDialog: false,
      statuslist: [
        this.$t('reportexport.inprogress'),
        this.$t('reportexport.completed'),
        this.$t('reportexport.nodata'),
        this.$t('reportexport.error'),
      ],
    };
  },
  components: {
    ParamDialog,
  },
  computed: {
    createbtndisabled() {
      const {
        selectedmachine,
        selectedreason,
        createstartdate,
        createenddate,
      } = this;
      return !selectedmachine
              || !selectedreason
              || !createstartdate
              || !createenddate;
    },
    searchbtndisabled() {
      const {
        searchstartdate,
        searchenddate,
      } = this;
      return !searchstartdate || !searchenddate;
    },
  },
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapActions('reportExport', ['getElement', 'postElement', 'deleteElement', 'updateElement', 'deleteReportFile']),
    ...mapActions('user', ['getMe']),
    async init() {
      this.reportexportheaders = this.reportexporttags.map((tag) => ({
        text: this.$t(`reportexport.table.${tag}`),
        value: tag,
      }));
      this.reportlist = await this.getElement({ elementname: 'reportlist' });
    },
    async search(payload) {
      let query = '';
      this.reportexport = [];
      console.log(payload, 'payload');
      if (payload) {
        const {
          reportname,
          startdate,
          enddate,
        } = payload;
        this.report = { name: reportname };
        this.searchstartdate = `${startdate.toString().substr(0, 4)}-${startdate.toString().substr(4, 2)}-${startdate.toString().substr(6, 2)}`;
        this.searchenddate = `${enddate.toString().substr(0, 4)}-${enddate.toString().substr(4, 2)}-${enddate.toString().substr(6, 2)}`;
        console.log(startdate, this.searchstartdate, 'this.searchstartdate');
        query = `?query=(startdate>=${startdate}%26%26startdate<=${enddate})`;
        query += `%7C%7C(enddate>=${startdate}%26%26enddate<=${enddate})`;
        query += `%26%26reportname=="${reportname}"`;
      } else {
        const searchstartdate = Number(this.searchstartdate.split('-').join(''));
        const searchenddate = Number(this.searchenddate.split('-').join(''));
        console.log(searchstartdate, searchenddate, 'this.searchenddate');
        if (searchstartdate > searchenddate) {
          this.setAlert({
            show: true,
            type: 'error',
            message: this.$t('reportexport.endtimeerrortext'),
          });
          return;
        }
        query = `?query=(startdate>=${searchstartdate}%26%26startdate<=${searchenddate})`;
        query += `%7C%7C(enddate>=${searchstartdate}%26%26enddate<=${searchenddate})`;
        if (this.report) {
          query += `%26%26reportname=="${this.report.name}"`;
        }
      }
      console.log(query, 'query');
      this.saving = true;
      const reportexportlist = await this.getElement({ elementname: 'reportexport', query });
      this.reportexportlist = reportexportlist.map((item) => ({
        ...item,
        statusformat: this.statuslist[Number(item.status)],
      }));
      this.saving = false;
    },
    async handleDelete() {
      if (await this.$root.$confirm.open(
        this.$t('reportexport.alertconfirmtitle'),
        this.$t('reportexport.alertconfirmtext'),
      )) {
        this.saving = true;
        const results = await Promise.all(this.reportexport
          .map(async (item) => {
            let result = null;
            if (item.path) {
              result = await this.deleteReportFile({ query: `links=${item.path}` });
            }
            if (result || !item.path) {
              await this.deleteElement({
                elementname: 'reportexport',
                id: item._id,
              });
              return true;
            }
            return false;
          }));
        this.saving = false;
        if (results.every((i) => i)) {
          this.setAlert({
            show: true,
            type: 'success',
            message: this.$t('reportexport.deletedsuccesstext'),
          });
          if (this.searchstartdate && this.searchenddate) {
            this.search();
          }
        } else {
          this.setAlert({
            show: true,
            type: 'error',
            message: this.$t('reportexport.deletederrortext'),
          });
        }
      }
    },
    handleDownload(item) {
      window.open(`http://121.196.182.101/reportexport/${item.path}`);
    },
    reset() {
      this.selectedmachine = '';
      this.selectedreason = '';
      this.createstartdate = '';
      this.createenddate = '';
    },
  },
  async created() {
    this.init();
  },
};
</script>
<style>
  .rag-amber{
    color: blue;
    text-decoration: underline;
  }
</style>
